import decode from 'jwt-decode';
import moment from 'moment';

export default class AuthService {
    constructor(domain) {
        this.domain = domain || 'https://api.swgrlynx.com';
        this.fetch = this.fetch.bind(this);
        this.login = this.login.bind(this);
        this.getProfile = this.getProfile.bind(this)
    }

    login(name, password) {
        // Get a token
        return this.fetch(`${this.domain}/login`, {
            method: 'POST',
            body: JSON.stringify({
                name,
                password
            })
        }).then(res => {
            this.setToken(res.token);
            return Promise.resolve(res);
        })
    }
    refreshToken() {
        const token = this.getToken();
        const decoded = decode(token);
        let threshold = decoded.expires;
        let now = moment();
        let tokenReadyForRefresh = now.add(15, 'minutes').isAfter(decoded.expires);
        if (tokenReadyForRefresh) {
            return this.fetch(`${this.domain}/tokenRefresh`, {
                method: 'GET'
            }).then(res => {
                this.setToken(res.token);
            })
        }

    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken();
        return !!token && this.isTokenExpired(token) // handwaiving here
    }
    lock() {
        return false;
    }

    isTokenExpired(token) {
        try {

            const decoded = decode(token);
            let now = moment();
            //let isTokenValid = now <= decoded.expires;
            return moment(now).isBefore(decoded.expires);
        }
        catch (err) {
            return false;
        }
    }


    setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken)
    }

    getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    }

    logout() {
        // Clear user token and profile data from localStorage
        localStorage.removeItem('id_token');
    }

    getProfile() {
        return decode(this.getToken());
    }


    fetch(url, options) {
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => response.json())
    }

    _checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) {
            return response
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/AuthService.js